import { listenCapabilities, type NavigationConfig } from '@ingenico/react-section-utils';
import type { DeviceManagementSpiPort } from './domain/hexa/ports/spi.model';

export function deviceManagementPrivateNavigation(spi: DeviceManagementSpiPort): NavigationConfig {
  return [
    {
      labelKey: 'navigation.page.devices',
      icon: 'devices',
      order: 1,
      children: [
        {
          labelKey: 'navigation.page.virtualDevices',
          href: 'virtual-devices',
        },
      ],
    },
    {
      labelKey: 'navigation.page.syncConfiguration',
      icon: 'devices',
      href: 'sync-configuration',
      order: 2,
      onlyShowWhen: listenCapabilities(spi, [], ['logicalDevice.msSyncConfiguration']),
    },
  ];
}
